function Contact() {
  return (
    <div className="wrapper contact">
        <h2>Contact</h2>
        <p className="body">Want to get in touch? I’m currently open to new opportunities and would love to hear from you. You can reach me at any of the following:</p>
        <ul>
            <li>Email: <a href="mailto:contact.shelly.tan@gmail.com" aria-label="Email">contact.shelly.tan@gmail.com</a></li>
            <li>Twitter/X: <a href="https://x.com/Tan_Shelly" target="_blank" rel="noopener noreferrer" aria-label="Twitter">@tan_shelly</a></li>
            <li>LinkedIn: <a href="https://www.linkedin.com/in/shelly-tan-842a1b2b/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">Shelly Tan</a></li>
        </ul>
    </div>
  );
}

export default Contact;
